<template>
    <div class="footer">
        <div class="container">
            <p style="padding-top: 65px;">Copyright ©2022：bjrs.org.cn 北京软数信息科技研究院   <a href="http://beian.miit.gov.cn/" style="color:#FFF" target="_blank">京ICP备16059467号-5</a></p>
            <p>地 址：{{webConfigs.address}} 邮编：000000 </p>
            <p>电话：{{webConfigs.mobile}} </p>
        </div>
    </div>
</template>
<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  props: {
    plates: Array,
    webConfigs: Object,
  },
  data() {
    return {
      webConfig: {},
      global,
    };
  },
  mounted() {},
};
</script>

<style>
.container{
  text-align: left;
}
.footer .container p{
      line-height: 43px;
}
.footer img{
  width: 135px;
    height: 135px;
    float: right;
    top: -128px;
    position: relative;
}
.footer span{
  float: right;
    top: 12px;
    position: relative;
    right: -142px;
    font-size: 18px;
    letter-spacing: 10px;
}
</style>
